

import { Link } from 'react-router-dom';
import { getLegacyServicesData, services as servicesData } from '../utils/dataModel';

const Services = () => {
  const services = getLegacyServicesData();

  return (
    <section className="services">
      <div className="services-container">
        <div className="services-header">
          <h2>How We Bridge Strategy and Implementation</h2>
          <p className="services-subtitle">
            We've spanned the full spectrum — from business problem framing to data infrastructure 
            to model development to user-facing productization. We don't just build models; we build 
            the systems that make them useful.
          </p>
        </div>
        <div className="services-grid">
          {services.map((service, index) => {
            const serviceData = servicesData[index]; // Get the corresponding service data with ID
            return (
              <Link key={index} to={`/services/${serviceData.id}`} className="service-card-link">
                <div className="service-card">
                  <div className="service-icon">
                    <img 
                      src={serviceData.image} 
                      alt={service.title}
                      className="service-image"
                    />
                  </div>
                  <div className="service-content">
                    <h3>{service.title}</h3>
                    <p className="service-description">{service.description}</p>
                    <p className="service-projects">{service.projects}</p>
                    <span className="service-link">
                      Learn more →
                    </span>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
        
      </div>
    </section>
  );
};

export default Services;